module.exports = __webpack_public_path__ + "static/img/Machine@2x.c24049d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sodastream/Machine@2x.png
// module id = Js51
// module chunks = 0